export function isAfroEthnicity(value) {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  return (
    normalized.includes('afro') ||
    normalized.includes('negro') ||
    normalized === 'et_02' ||
    normalized === 'et_afro'
  );
}
